module.exports = __webpack_public_path__ + "img/close.cac87c97.png";